<template>
  <div>
    <viewer v-if="viewer">
      <img :src="resizeImg" :data-source="src" :alt="alt" :onerror="onerror"/>
    </viewer>
    <img v-else :src="resizeImg" :alt="alt" :onerror="onerror"/>
  </div>
</template>

<script>
/**
 * OSS图片缩放
 * https://help.aliyun.com/document_detail/44688.html
 */
export default {
  name: 'OssImg',
  props: {
    // 是否需要图片放大预览
    viewer: {type: Boolean, default: true},
    src: {type: String, default: ''},
    alt: {type: String, default: ''},
    /**
     * lfit：（默认）等比缩放，限制在指定w与h的矩形内的最大图片
     * mfit：等比缩放，延伸出指定w与h的矩形框外的最小图片
     * fill：固定宽高，将延伸出指定w与h的矩形框外的最小图片进行居中裁剪
     * pad：固定宽高，缩略填充
     * fixed：固定宽高，强制缩略
     */
    m: {type: String, default: 'lfit'},
    // 指定目标缩略图的宽度，1-4096
    w: {type: Number, default: null},
    // 指定目标缩略图的高度，1-4096
    h: {type: Number, default: null},
    // 指定目标缩略图的最长边，1-4096
    l: {type: Number, default: null},
    // 指定目标缩略图的最短边，1-4096
    s: {type: Number, default: null},
    /**
     * 指定当目标缩略图大于原图时是否处理
     * 1：（默认）不处理
     * 0：处理
     */
    limit: {type: Number, default: null},
    /**
     * 当缩放模式选择为 pad（缩略填充）时，可以选择填充的颜色(默认是白色)参数的填写方式
     * 采用 16 进制颜色码表示，如 00FF00（绿色）
     * [000000-FFFFFF]
     */
    color: {type: String, default: null}
  },
  data () {
    return {
      resizeImg: '',
      onerror: ''
    }
  },
  mounted () {
    // 获取缩放后的图片src
    this.getResizeImg()
    // 获取图片加载错误的处理
    this.handleOnerror()
  },
  watch: {
    src () {
      // 获取缩放后的图片src
      this.getResizeImg()
      // 获取图片加载错误的处理
      this.handleOnerror()
    }
  },
  methods: {
    /**
     * 获取缩放后的图片src
     */
    getResizeImg () {
      let suffixArr = []
      suffixArr.push('?x-oss-process=image/resize')
      if (this.m) {
        suffixArr.push(`,m_${this.m}`)
      }
      if (this.w && this.w >= 1 && this.w <= 4096) {
        suffixArr.push(`,w_${this.w}`)
      }
      if (this.h && this.h >= 1 && this.h <= 4096) {
        suffixArr.push(`,h_${this.h}`)
      }
      if (this.l && this.l >= 1 && this.l <= 4096) {
        suffixArr.push(`,l_${this.l}`)
      }
      if (this.s && this.s >= 1 && this.s <= 4096) {
        suffixArr.push(`,s_${this.s}`)
      }
      if (this.limit && this.limit === 0 && this.limit === 1) {
        suffixArr.push(`,limit_${this.limit}`)
      }
      if (this.color) {
        suffixArr.push(`,color_${this.color}`)
      }
      this.resizeImg = this.src + suffixArr.join('')
    },

    /**
     * 获取图片加载错误的处理，失败后使用原图
     * 文件大小不能超过 20MB
     * ImageTooLarge
     * Maximal size of image supported is 20971520
     */
    handleOnerror () {
      let errorArr = []
      // 防止出现死循环
      errorArr.push('this.onerror=null;')
      // 替换缩放图为原图
      if (this.src) {
        errorArr.push(`this.src='${this.src}';`)
      }
      // 设置图片最大宽高
      if (this.l && this.l >= 1 && this.l <= 4096) {
        errorArr.push(`this.style='max-width:${this.l}px;max-height:${this.l}px;'`)
      } else {
        let styleArr = []
        if (this.w && this.w >= 1 && this.w <= 4096) {
          styleArr.push(`max-width:${this.w}px;`)
        }
        if (this.h && this.h >= 1 && this.h <= 4096) {
          styleArr.push(`max-height:${this.h}px;`)
        }
        errorArr.push(`this.style='${styleArr.join('')}'`)
      }
      this.onerror = errorArr.join('')
    }
  }
}
</script>

<style scoped>
img {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/oss-img/index.vue